import type { ContactPreference } from '@gql/graphql';

export interface UnsubscribePageData {
  loading: boolean;
  onChangeContactPreferenceClick: (contactPreferences: ContactPreference[], value: boolean) => void;
  isRegisteredUser: boolean;
}

export interface UnsubscribePageProps extends UnsubscribePageData {}

export interface UnsubscribePageFormValues {
  email?: string;
  contactPreferences?: ContactPreference[];
}
